import { EventEmitter } from 'events';

import * as $ from 'jquery';

import * as NullUtil from 'src/shared/NullUtil';
import { hasValue } from 'src/shared/NullUtil';
import { UltraContentEditableFilter } from 'src/shared/wysiwyg/ultra/UltraContentEditableFilter';
import { UltraEditorController } from 'src/shared/wysiwyg/ultra/UltraEditorController';

import { IEditorListener } from '../IEditorListener';


export interface IQuillEditorListenerOptions {
    checkIntervalMs?: number;
    root?: HTMLElement;
}

export class UltraEditorListener implements IEditorListener<UltraEditorController> {
    private readonly checkIntervalMs: number;
    protected readonly root: HTMLElement;
    protected readonly emitter = new EventEmitter();

    // Internal state
    protected readonly instances: {id: string, container: HTMLElement, editor: UltraEditorController}[] = [];
    private interval?: any;

    constructor(
        protected readonly baseUrl: string,
        protected readonly i18n: any,
        options: IQuillEditorListenerOptions = {}
    ) {
        this.checkIntervalMs = hasValue(options.checkIntervalMs) ? options.checkIntervalMs : 1000;
        this.root = hasValue(options.root) ? options.root : document.body;
    }

    public onAddEditor(cb: (id: string, editor: UltraEditorController) => void): void {
        this.emitter.on('add-editor', cb);
    }

    public onRemoveEditor(cb: (id: string, editor: UltraEditorController) => void): void {
        this.emitter.on('remove-editor', cb);
    }

    /** Start listening for editors on the global scope. */
    public start(): void {
        this.syncEditors();
        this.interval = setInterval(() => this.syncEditors(), this.checkIntervalMs);
    }

    /** Stop listening for editors on the global scope. */
    public stop(): void {
        if (NullUtil.hasValue(this.interval)) {
            clearInterval(this.interval);
            this.interval = undefined;
        }

        // we don't expect any instances to exist at this point, but just in case
        this.instances.forEach(({ id, editor }) => this.emitter.emit('remove-editor', id, editor));
        this.instances.length = 0;
        this.emitter.removeAllListeners();
    }

    protected getEditors($editors: JQuery<HTMLElement>) {
        return $editors.toArray()
            .map((e) => {
                return {
                    'editable': [e].filter(this.getContentFilter()).length > 0,
                    'editor': e
                };
            });
    }

    protected flagAddedEditors(editors: { editable: boolean; editor: HTMLElement; }[]) {
        // Now flag editors that have been added
        for (const container of editors) {
            if (!NullUtil.hasValue(this.instances.find((i) => i.container === container.editor)) &&
                container.editable) {
                const id = Math.random().toString().slice(2);
                const editor = new UltraEditorController(this.baseUrl, this.i18n, container.editor);
                this.instances.push({ id, 'container': container.editor, editor });
                this.emitter.emit('add-editor', id, editor);
            }
        }
    }

    protected getContentFilter() {
        return UltraContentEditableFilter.getContentEditableFilter();
    }

    protected syncEditors(): void {
        const $editors = $(this.root).find('.bbml-editor-parent');
        const editors = this.getEditors($editors);
        // First flag editors that have been removed
        if (editors.filter((e) => !e.editable).length > 0) {
            for (const instance of this.instances) {
                this.emitter.emit('remove-editor', instance.id, instance.editor);
                this.instances.splice(this.instances.indexOf(instance), 1);
            }
        }
        this.flagAddedEditors(editors);
    }
}
